type input = {
  xbox: string,
  playstation: string,
  battleNet: string,
  steam: string,
  microsoftStore: string
}

export const labelOptions = ({
  xbox,
  playstation,
  battleNet,
  steam,
  microsoftStore
}: input) => {
  return [
    { label: `${xbox} / ${microsoftStore}`, value: "xbox" },
    { label: playstation, value: "playstation" },
    { label: battleNet, value: "battle.net" },
    { label: steam, value: "steam" }
  ];
}